module.exports = __webpack_public_path__ + "static/img/zongku.5c44b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zongku.jpg
// module id = 2qkN
// module chunks = 1